import React, { useState, useEffect } from "react";
import GlobalStyles from 'styles/GlobalStyles';
import SignUp from './components/Signup.js';
import Login from './components/Login.js';
import RestaurantLandingPage from './components/RestaurantLandingPage.js';
import TermsOfService from './components/TermsOfService.js';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Boutique from "components/Boutique.js";
import './Boutique.css';
import './ProductDetails.css';
import './Checkout.css';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// Admin Dashboard and Other Components
import ProductDetails from "components/ProductDetails.js";
import CheckoutFrom from "components/CheckoutForm.js";
import ForgotPassword from "components/ForgotPassword.js";
import ResetPassword from "components/ResetPassword.js";
import Orders from "components/Admin/Orders.jsx";
import Profile from "components/Admin/Profile.js";
import OrdersAdmin from "components/AdminDashbord/Orders.jsx";
import ProduitsAdmin from "components/AdminDashbord/Produits.jsx";
import DashbordAdmin from "components/AdminDashbord/Dashbord.jsx";
import PaymentAdmin from "components/AdminDashbord/Payment.jsx";
import AdminAnnouncement from "components/AdminDashbord/AdminAnnouncement.jsx";
import UserAdmin from "components/AdminDashbord/UserAdmin.jsx";
import ClientAdmin from "components/AdminDashbord/ClientAdmin.jsx";
import Retraite from "components/AdminDashbord/Retraite.jsx";
import ProtectedRoute from "./ProtectedRoute"; // Import ProtectedRoute component
import Light from "components/headers/light.js";
import LightAdmin from "components/headers/lightAdmin.js";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import BuyerDashbord from "components/buyer/BuyerDashbord.jsx";
import Buyer from "components/AdminDashbord/Buyer.jsx";
import Purchase from "components/AdminDashbord/Purchase.jsx";
import TwoColContactUsWithIllustrationFullForm from "components/forms/TwoColContactUsWithIllustrationFullForm.js";
import Contact from "Contact.js";
import AnnouncementBanner from 'components/AnnouncementBanner.jsx';

export default function App() {
  const [role, setRole] = useState(null);
  // useEffect(() => {
  //   const handleTabClose = (event) => {
  //     localStorage.removeItem("isAdmin"); // Supprime isAdmin
  //   };
  
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === "hidden") {
  //       localStorage.removeItem("isAdmin");
  //     }
  //   };
  
  //   window.addEventListener("beforeunload", handleTabClose);
  //   document.addEventListener("visibilitychange", handleVisibilityChange);
  
  //   return () => {
  //     window.removeEventListener("beforeunload", handleTabClose);
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   };
  // }, []);
  
  
  useEffect(() => {
    const storedRole = localStorage.getItem('isAdmin'); 
    if (storedRole !== null) {
      setRole(storedRole);
    } else {
      setRole(''); // Handle this case (e.g., redirect to login page)
    }
  }, []);

  // Show a loading screen while checking the role or redirect if invalid
  if (role === null) {
    return <div>Loading...</div>;
  }

  // if (role === '') {
  //   // If role is empty or invalid, redirect to login
  //   return <Navigate to="/login" />;
  // }

  return (
    <>
      <GlobalStyles />
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<RestaurantLandingPage />} />

          <Route path="/signup" element={<SignUp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/contact" element={<Contact/>} />

          {/* Protected Routes for Distributor */}
          <Route
            path="/Boutique"
            element={
              <ProtectedRoute allowedRoles={['0']}>
                <Boutique />
              </ProtectedRoute>
            }
          />
          <Route
            path="/product-details/:id"
            element={
              <ProtectedRoute allowedRoles={['0']}>
                <ProductDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/checkout"
            element={
              <ProtectedRoute allowedRoles={['0']}>
                <CheckoutFrom />
              </ProtectedRoute>
            }
          />
 <Route
            path="/announcement"
            element={
              <ProtectedRoute allowedRoles={['0']}>
                <AnnouncementBanner />
              </ProtectedRoute>
            }
          />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={['0']}>
                <Orders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute allowedRoles={['0']}>
                <Profile />
              </ProtectedRoute>
            }
          />

          {/* Admin-only routes */}
          <Route
            path="/dashbord-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <DashbordAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/order-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <OrdersAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/produits-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <ProduitsAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <PaymentAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <UserAdmin />
              </ProtectedRoute>
            }
          />
  <Route
            path="/AdminAnnouncement"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <AdminAnnouncement />
              </ProtectedRoute>
            }
          />


          <Route
            path="/client-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <ClientAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/retraite"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <Retraite />
              </ProtectedRoute>
            }
          />
              <Route
            path="/purchase"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <Purchase />
              </ProtectedRoute>
            }
          />
      <Route
            path="/buyerAdmin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <Buyer />
              </ProtectedRoute>
            }
          />
          {/* buyer only routes */}
  
          <Route path="/buyer" element={<BuyerDashbord/>} />


        </Routes>
      </Router>
    </>
  );
}